import {
  SET_BLOCKS,
  UPDATE_BLOCK,
  SET_BLOCKDATA,
  SET_SETUPDATA,
  UPDATE_SETUPDATA,
  SET_USERDATA,
  DELETE_BLOCKS,
  SET_BLOCK_PROGRESS,
  UPDATE_BLOCK_PROGRESSSETTINGS,
  UPDATE_BLOCK_SHARINGSETTINGS,
  UPDATE_BLOCK_GROUPWORKSETTINGS,
  UPDATE_PORTFOLIO_SETTINGS,
  MOVE_BLOCK_START,
  UPDATE_BLOCK_AUTOSAVE_START,
  UPDATE_BLOCK_AUTOSAVE_FINISHED,
  UPDATE_BLOCK_AUTOSAVE_FAILED,
  BLOCK_DATA_FETCH_SUCCESS,
} from './actions';
import { ResourceApi } from '../../resource/Resource';

/**
 * Populates the store with block data by ID.
 */
export function setBlocks(blocks) {
  return {
    type: SET_BLOCKS,
    blocks,
  };
}

/**
 * Updates any changes in a block (locally).
 */
export function updateBlock(blockID, changes) {
  return {
    type: UPDATE_BLOCK,
    blockID,
    changes,
  };
}

/**
 * Update block completion/assessment data
 * (this shouldn't be needed, but there is duplication of data
 * "isCompleted" within the Block which needs to be kept in sync
 * Recommendation: change backend "data" call in BlockResource
 * to only pass around this data in one place)
 * N.B. this should also (ideally) update page completion and
 * class progress as well, but this is currently handled separately
 */
export function updateBlockAssessment(blockID, changes) {
  return {
    type: UPDATE_BLOCK,
    blockID,
    changes: {
      assessment: changes,
      isCompleted: changes.isCompleted,
    },
  };
}

/**
 * Update the block's user attachment data
 */
export function updateBlockAttachments(blockID, changes) {
  return {
    type: UPDATE_BLOCK,
    blockID,
    changes: {
      userAttachments: changes,
    },
  };
}

/**
 * Replace a part of block data.
 *
 * updateBlock() has issues when the data structure changes due to
 * Immutable.Map.merge() function not being able to compare different field
 * types.
 */
export function setBlockData(blockId, changes) {
  return {
    type: SET_BLOCKDATA,
    blockId,
    changes,
  };
}

/**
 * Set block setupData.
 */
export function setSetupData(blockID, setupData, timestamp) {
  return {
    type: SET_SETUPDATA,
    blockID,
    setupData,
    timestamp,
  };
}

/**
 * Update block setupData.
 */
export function updateSetupData(blockID, setupData) {
  // , timestamp
  return {
    type: UPDATE_SETUPDATA,
    blockID,
    setupData,
    //     timestamp,
  };
}

/**
 * Set the user's progress for this block.
 * @param value numeric 0.0 to 1.0
 */
export function setBlockProgress(blockID, value) {
  return {
    type: SET_BLOCK_PROGRESS,
    blockID,
    value,
  };
}

export function deleteBlocks(blockIds) {
  return {
    type: DELETE_BLOCKS,
    blockIds,
  };
}

export function moveBlock(
  draggedBlock,
  positionSetupData,
  placement,
  targetBlock
) {
  return {
    type: MOVE_BLOCK_START,
    draggedBlock,
    positionSetupData,
    placement,
    targetBlock,
  };
}

/**
 * Set the assessment progress percentage for the block.
 * @param value numeric 0.0 to 1.0
 */
export function updateProgressSettings(blockID, changes) {
  return {
    type: UPDATE_BLOCK_PROGRESSSETTINGS,
    blockID,
    changes,
  };
}

/**
 * Set the default sharing settings for the block.
 * These settings are used as defaults for the sharing dialog (which may allow
 * the student to change settings further)
 *
 * @param value numeric 0.0 to 1.0
 */
export function updateSharingSettings(
  blockID,
  accessType,
  scheme,
  groups,
  condition,
  revealTime
) {
  return {
    type: UPDATE_BLOCK_SHARINGSETTINGS,
    blockID,
    accessType,
    scheme,
    groups,
    condition,
    revealTime,
  };
}

export function updateGroupWorkSettings(
  blockID,
  isGroupWorkActivity,
  groupType
) {
  return {
    type: UPDATE_BLOCK_GROUPWORKSETTINGS,
    blockID,
    isGroupWorkActivity,
    groupType,
  };
}

/**
 * Set block userData.
 */
export function setUserData(blockID, userData, timestamp) {
  return {
    type: SET_USERDATA,
    blockID,
    userData,
    timestamp,
  };
}

export function updatePortfolioSettings(blockID, isPortfolioEnable) {
  return {
    type: UPDATE_PORTFOLIO_SETTINGS,
    blockID,
    isPortfolioEnable,
  };
}

export const updateAutoSaveStateForBlock = (blockId, text) => (dispatch) => {
  dispatch({
    type: UPDATE_BLOCK_AUTOSAVE_START,
    blockId,
    text,
  });

  return new Promise((resolve, reject) => {
    ResourceApi.update('block', blockId, 'updateAutoSaveStateForBlock', {
      text,
    }).then(
      () => {
        dispatch({
          type: UPDATE_BLOCK_AUTOSAVE_FINISHED,
          blockId,
        });
        resolve();
      },
      (error) => {
        dispatch({
          type: UPDATE_BLOCK_AUTOSAVE_FAILED,
          error,
        });
        reject(Error());
      }
    );
  });
};

// currently being used for mobile WebView widget
export function getBlockData(blockId, mountId) {
  return (dispatch) => {
    ResourceApi.read('block', blockId, 'getBlockData').then((result) => {
      dispatch({
        type: SET_BLOCKS,
        blocks: [result],
      });

      // deconstruct pageData needed from getBlockData response
      const pageData = (({ pageId, pageUrl, pagePath }) => ({
        id: pageId,
        pageUrl,
        path: pagePath,
      }))(result);
      // populate Pages and BlockPageUI store
      dispatch({
        type: BLOCK_DATA_FETCH_SUCCESS,
        pages: [pageData],
        blockId: result.id,
        mountId,
      });
    });
  };
}
